import type { ReorderPresets } from './types.js';
import { locateProxy } from '#~/agent/index.js';
import { StudioError } from '#~/error/index.js';

/**
 * Reorder the presets for the specified device.
 *
 * @param deviceId - The ID of the device for which the presets are to be reordered.
 * @param presetIds - New preset order.
 */
export const reorderPresets: ReorderPresets = async (deviceId, presetIds, token): Promise<void> => {
  try {
    const proxy = locateProxy(deviceId);

    if (!proxy) {
      throw new Error('CZ-131');
    }

    const mutation = Object.fromEntries(
      presetIds.map((presetId, index) => [presetId, { rank: index }])
    );

    await proxy.mutate(
      {
        control: {
          studio: {
            device: {
              [deviceId]: {
                control: {
                  presets: {
                    items: mutation
                  }
                }
              }
            }
          }
        }
      },
      {}
    );

    await proxy.save(token);
  } catch (cause) {
    throw new StudioError('Unable to reorder presets.', { cause });
  }
};
